<template>
  <div>
    <RfSequencePathsDisplayTable
      :key="computeKey"
      :paths="paths"
      :sequence="sequence"
      @delete="deletePath"
      @updateOrder="updateOrder"
    />
  </div>
</template>

<script>
import RfSequencePathsDisplayTable from "@/components/RfSequences/RfSequencePathsDisplayTable.vue";
import { cloneDeep } from "lodash-es";

export default {
  name: "RfSequencePaths",
  components: { RfSequencePathsDisplayTable },
  props: ["sequence"],
  data() {
    return {
      paths: cloneDeep(this.sequence.paths),
      computeKey: 0,
    };
  },
  computed: {
    orderedPaths() {
      return this.paths;
    },
  },
  watch: {
    orderedPaths(to) {
      this.computeKey++;
      this.updateOrder(to);
    },
  },
  methods: {
    deletePath(index) {
      this.paths.splice(index, 1);
    },
    fillModel(model) {
      model.paths = this.paths.map(item => {
        return {
          interaction_types: item.interaction_types,
          id: item.id,
          continue_interaction_types: item.continue_interaction_types,
          skip_interaction_types: item.skip_interaction_types,
        };
      });
    },
    updateOrder(paths) {
      this.paths = paths;
      this.$emit("savePaths");
    },
  },
};
</script>
